export const toolbarSettings = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ header: [1, false] }],
  ['image'], // image button
];
